import { makeStyles, Theme } from "@material-ui/core";
import { CSSProperties } from "@material-ui/core/styles/withStyles";

export default makeStyles((theme: Theme) => {
  const buttonStyle: CSSProperties = {
    marginLeft: theme.spacing(1)
  };

  return {
    modal: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    container: {
      width: "80%",
      backgroundColor: "#EFEFEF",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      borderRadius: theme.spacing(1)
    },
    titleWrapper: {
      ...theme.typography,
      fontSize: 16
    },
    contentWrapper: {},
    actionsWrapper: {
      display: "flex",
      justifyContent: "flex-end",
      paddingTop: theme.spacing(2)
    },
    okButton: { ...buttonStyle },
    cancelButton: { ...buttonStyle }
  };
});
